import { Component } from 'react';

export class SuccessCircleSVG extends Component<{
    className?: string;
    'data-testid'?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                data-testid={this.props['data-testid']}
                className={className}
                width="90"
                height="90"
                viewBox="0 0 90 90"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M43 73C60.6731 73 75 58.6731 75 41C75 23.3269 60.6731 9 43 9C25.3269 9 11 23.3269 11 41C11 58.6731 25.3269 73 43 73Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M43 73C60.6731 73 75 58.6731 75 41C75 23.3269 60.6731 9 43 9C25.3269 9 11 23.3269 11 41C11 58.6731 25.3269 73 43 73Z"
                        stroke="#EFEFEF"
                    />
                </g>
                <path
                    d="M54.4715 32.2794C45.2198 41.8183 44.0714 43.2394 38.6838 48.8159L32.5137 42.9812C32.176 42.6266 31.5478 42.6368 31.2211 43.002C30.8945 43.3674 30.9356 44.0138 31.3057 44.332L38.1077 50.7703C38.443 51.0878 39.0225 51.0743 39.3436 50.7415C45.4502 44.4453 46.0689 43.5391 55.7352 33.5727C56.0008 33.3058 56.0771 32.8593 55.9162 32.5149C55.5079 31.8433 54.9393 31.8997 54.4715 32.2792V32.2794Z"
                    fill="#0D9876"
                />
                <defs>
                    <filter
                        id="filter0_d"
                        x="0.5"
                        y="0.5"
                        width="89"
                        height="89"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        />
                        <feOffset dx="2" dy="4" />
                        <feGaussianBlur stdDeviation="6" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0689538 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
        );
    }
}
